import { render, staticRenderFns } from "./carrelloDropdown.vue?vue&type=template&id=0999f640&"
import script from "./carrelloDropdown.vue.ts?vue&type=script&lang=ts&"
export * from "./carrelloDropdown.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports